import { render } from "./CreateTypeHospitalisation.vue?vue&type=template&id=181294c2&scoped=true"
import script from "./CreateTypeHospitalisation.vue?vue&type=script&lang=js"
export * from "./CreateTypeHospitalisation.vue?vue&type=script&lang=js"

import "./CreateTypeHospitalisation.vue?vue&type=style&index=0&id=181294c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-181294c2"]])

export default __exports__